export const ROW_SPACE = 40;
export const OPTION_DROPDOWN_HEIGHT = 36;
export const MAP_AREA_HEIGHT = 280;
export const MAP_AREA_MARGIN_TOP = 16;
export const CALLBACK_ID_GET_LOCATION = 'GetLocation-DisplayShopSearch';
export const CALLBACK_ID_GET_LOCATION_EXPERT_SEARCH =
  'GetLocation-ExpertSearch';
export const VISIT_CONSULT_REQUEST_URL = '/visit-consult/request';
